import { Box, Button, Stack, Zoom } from "@mui/material";
import { Category } from "../../../../domain/model/Category";
import {
  COLOR_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_SECONDARY,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../../data/colors/Colors";
import { CustomCardView } from "../../../component/CustomCardView";
import { CustomImageView } from "../../../component/CustomImageView";
import { CustomTextView } from "../../../component/CustomTextView";
import {
  formatDate,
  getDominantColorOfImage,
  hasEnglishLetters,
} from "../../../../core/utils/Utils";
import { useEffect, useState } from "react";
import {
  ArrowDownwardRounded,
  ArrowRightAltRounded,
  ArrowRightRounded,
  CategoryOutlined,
  CategoryRounded,
} from "@mui/icons-material";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import { Product } from "../../../../domain/model/Product";

interface props {
  product: Product;
  index: number;
  href: string;
}

export function ProductsListItemView(props: props) {
  const { width } = useWindowDimensions();

  const product = props.product;
  return (
    <CustomCardView
      padding={0}
      borderRadius={6}
      children={
        <Button
          LinkComponent={"a"}
          fullWidth
          href={props.href}
          sx={{
            padding: 0,
            borderRadius: 6,
          }}
        >
          <Stack
            spacing={0}
            textTransform={"none"}
            width={"100%"}
            position={"relative"}
            height={400}
          >
            {product.imagesList &&
              product.thumbnailIndex != undefined &&
              product.thumbnailIndex < product.imagesList?.length && (
                <Zoom in timeout={500}>
                  <div>
                    <CustomImageView
                      height={280}
                      scale="contain"
                      width="100%"
                      src={
                        (product.imagesList[product.thumbnailIndex] as any)
                          .downloadUrl
                      }
                      props={{ borderRadius: 6 }}
                    />
                  </div>
                </Zoom>
              )}
            <Stack
              width={"100%"}
              position={"absolute"}
              bottom={0}
              zIndex={2}
              pr={2}
              pl={2}
              pb={1}
              pt={1}
              spacing={2}
              sx={{
                direction: hasEnglishLetters(product.name ?? "")
                  ? "ltr"
                  : "rtl",
                backdropFilter: "blur(20px)",
                backgroundColor: "rgba(206, 200, 200, 0.4)",
                borderTop: "0.5px solid gray",
                borderRadius: 6,
              }}
            >
              <Stack>
                <CustomTextView
                  text={product.name}
                  fontWeight="bold"
                  fontSize={22}
                  props={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    overflowWrap: "break-word",
                    whiteSpace: "nowrap",
                  }}
                />
                <CustomTextView
                  text={`${(product?.category as any)?.title}`}
                  fontSize={16}
                  textColor={COLOR_LIGHT_GRAY}
                  fontWeight="300"
                  props={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    overflowWrap: "break-word",
                    whiteSpace: "nowrap",
                  }}
                />
              </Stack>

              <Stack
                direction={"row"}
                spacing={3}
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{ direction: "ltr" }}
              >
                <Stack alignItems={"center"} direction={"row"} spacing={1}>
                  <CustomTextView
                    text={`${product.actualPrice?.toFixed(2)} QR`}
                    fontSize={16}
                    fontWeight="bold"
                    textAlign="center"
                  />
                  <ArrowRightAltRounded
                    sx={{ color: COLOR_LIGHT_GRAY }}
                    fontSize="small"
                  />
                  <CustomTextView
                    text={`${product.minimumPrice?.toFixed(2)} QR`}
                    fontSize={16}
                    fontWeight="bold"
                    textAlign="center"
                  />
                </Stack>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <CustomTextView
                    text={"by"}
                    fontSize={12}
                    textColor={COLOR_LIGHT_GRAY}
                  />
                  <CustomTextView
                    text={`${product.priceDecreaseRate?.toFixed(2)} QR`}
                    fontSize={16}
                  />
                  <CustomTextView
                    text={"/ second"}
                    fontSize={12}
                    textColor={COLOR_LIGHT_GRAY}
                  />
                </Stack>
              </Stack>
              <CustomTextView
                text={`Going live at ${
                  product.goingLiveAt
                    ? formatDate(new Date(product.goingLiveAt))
                    : "err"
                }`}
                fontSize={14}
                textColor={COLOR_LIGHT_GRAY}
                fontWeight="300"
                props={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  overflowWrap: "break-word",
                  whiteSpace: "nowrap",
                }}
              />
            </Stack>
          </Stack>
        </Button>
      }
    />
  );
}
